module.exports = __webpack_public_path__ + "img/palm-x6-plus-4.b26fbaba.png";